{
  "LOGIN": {
    "TITLE": "Logg inn i Chatwoot",
    "EMAIL": {
      "LABEL": "E-post",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Vennligst skriv inn en gyldig e-postadresse"
    },
    "PASSWORD": {
      "LABEL": "Passord",
      "PLACEHOLDER": "Passord"
    },
    "API": {
      "SUCCESS_MESSAGE": "Login successful",
      "ERROR_MESSAGE": "Could not connect to Woot server. Please try again.",
      "UNAUTH": "Username or password is incorrect. Please try again."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Login with Google",
      "BUSINESS_ACCOUNTS_ONLY": "Please use your company email address to login",
      "NO_ACCOUNT_FOUND": "We couldn't find an account for your email address."
    },
    "FORGOT_PASSWORD": "Glemt passord?",
    "CREATE_NEW_ACCOUNT": "Opprett ny konto",
    "SUBMIT": "Logg inn",
    "SAML": {
      "LABEL": "Login via SSO",
      "TITLE": "Initiate Single Sign-on (SSO)",
      "SUBTITLE": "Enter your work email to access your organization",
      "BACK_TO_LOGIN": "Login via Password",
      "WORK_EMAIL": {
        "LABEL": "Work Email",
        "PLACEHOLDER": "Enter your work email"
      },
      "SUBMIT": "Continue with SSO",
      "API": {
        "ERROR_MESSAGE": "SSO authentication failed. Please check your credentials and try again."
      }
    }
  }
}
